// extracted by mini-css-extract-plugin
module.exports = {"featureTag":"style_featureTag__jp_VD"};